import { FEATURE_FLAG_ON } from './flagConstants';
import type { FlagVariant } from './index';

/**
 * Whether the multi-product cart rollout (`Flags.MULTI_CART`, CPS-7479) is on
 * for the given variant. Kept free of client-only imports so it is the single
 * definition of "on" for both a server `getVariant()` result and a client
 * `useFlags` entry; the first server-side call site lands with the later cart
 * stories. Falls back to `key` because the REST client
 * (`AmplitudeHttpRemoteEvaluationClient`) returns variants without `value`.
 */
export const isMultiCartEnabled = (variant?: FlagVariant): boolean =>
  (variant?.value ?? variant?.key) === FEATURE_FLAG_ON;
